export const TRAVEL_FUSION = 'travelFusion'
export const AMADEUS = 'amadeus'
export const JETSTAR = 'jetstar'
